import { useEffect, useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import { api } from "@/lib/api";
import { photoUrl } from "@/lib/photos";

export default function Experiences({ property }) {
  const { t } = useLang();
  const items = t("experiences.items");
  const [uploaded, setUploaded] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/photos?property_id=${property.id}`);
        if (cancelled) return;
        setUploaded(data?.sections?.experiencias || []);
      } catch {
        if (!cancelled) setUploaded([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [property.id]);

  const getImageFor = (i) => {
    if (uploaded && uploaded.length > 0) {
      const p = uploaded[i % uploaded.length];
      if (p) return photoUrl(p);
    }
    return property.experiences_images[i % property.experiences_images.length];
  };

  const getAltFor = (i, fallback) => {
    if (uploaded && uploaded.length > 0) {
      const p = uploaded[i % uploaded.length];
      if (p?.seo_alt) return p.seo_alt;
    }
    return fallback;
  };

  return (
    <section id="momentos" data-testid="experiences-section" className="bg-[#FAFAF9] py-24 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-20">
          <p className="text-eyebrow text-[#E07A5F] mb-4">{t("experiences.eyebrow")}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-stone-900">
            {t("experiences.title")}
          </h2>
        </div>

        <div className="space-y-24 md:space-y-32">
          {items.map((item, i) => {
            const isEven = i % 2 === 0;
            return (
              <div
                key={i}
                data-testid={`experience-${i}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center"
              >
                <div className={`md:col-span-7 ${isEven ? "" : "md:order-2"}`}>
                  <div className="aspect-[4/3] overflow-hidden bg-stone-200">
                    <img
                      src={getImageFor(i)}
                      alt={getAltFor(i, item.t)}
                      loading="lazy"
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms] ease-out"
                    />
                  </div>
                </div>
                <div className={`md:col-span-5 ${isEven ? "" : "md:order-1"}`}>
                  <div className="text-eyebrow text-stone-400 mb-3">
                    0{i + 1} / 0{items.length}
                  </div>
                  <h3 className="font-serif-display text-3xl md:text-4xl lg:text-5xl text-stone-900 leading-[1.05] mb-5">
                    {item.t}
                  </h3>
                  <p className="text-stone-600 text-lg leading-relaxed">{item.d}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
